import { render, staticRenderFns } from "./PublicFavoriteShare.vue?vue&type=template&id=bb3c2f2c"
import script from "./PublicFavoriteShare.vue?vue&type=script&lang=js"
export * from "./PublicFavoriteShare.vue?vue&type=script&lang=js"
import style0 from "./PublicFavoriteShare.vue?vue&type=style&index=0&id=bb3c2f2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports